import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Link,
    Chip,

} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import { EyeIcon } from "../icons";
import CommonDataTable from "../components/common/CommonDataTable";
import universityDataTable from "../components/UniversityManage/data";
import { BackArrowIcon, GoToLiveIcon } from '../icons'
import { useNavigate } from 'react-router-dom'
import UniversitySummary from '../components/university-table/UniversitySummary';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import CommonFilterTab from "../components/common/CommonFilterTab";
import Skeleton from '@mui/material/Skeleton';
import FilterListIcon from '@mui/icons-material/FilterList';
import ManageColumns from "../components/common/ManageColumns";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
const UniversityManagement = () => {
    const [loading, setLoading] = React.useState(true);
    const [filtersEnabled, setFiltersEnabled] = React.useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 5000);

        return () => clearTimeout(timer); // cleanup
    }, []);
    const navigate = useNavigate()
    const [searchFilter, setSearchFilter] = React.useState({})
    function getStatusClass(status) {
        switch (status) {
            case 'Live':
                return 'status-live'
            case 'Draft':
                return 'status-draft'
            case 'Pending':
                return 'status-pending'
            case 'Deactivated':
                return 'status-deactivated'
            default:
                return ''
        }
    }
    function getStatusColor(status) {
        switch (status) {
            case 'Live':
                return '#22c55e' // green
            case 'Draft':
                return '#64748b' // grayish
            case 'Pending':
                return '#f97316' // orange
            case 'Deactivated':
                return '#ef4444' // red
            default:
                return '#999'
        }
    }
    function getStatusBgColor(status) {
        switch (status) {
            case 'Live':
                return '#fff'
            case 'Draft':
                return '#fff'
            case 'Pending':
                return '#fff'
            case 'Deactivated':
                return '#fff'
            default:
                return '#fff'
        }
    }

    function getStatusTextColor(status) {
        switch (status) {
            case 'Live':
                return '#363853' // darker green
            case 'Draft':
                return '#363853' // darker gray
            case 'Pending':
                return '#363853' // darker orange
            case 'Deactivated':
                return '#363853' // darker red
            default:
                return '#666'
        }
    }

    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 60,
        },
        {
            field: "universityId",
            headerName: "University Id",
            minWidth: 130,
        },
        {
            field: "universityDetails",
            headerName: "University",
            minWidth: 220,
            renderCell: ({ value }) => {
                if (!Array.isArray(value)) return null;
                return (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        {value.map((item, index) => (
                            <Box
                                key={index}
                                sx={{ display: "flex", alignItems: "center", gap: 1 }}
                            >
                                {item.image && (
                                    <img
                                        src={item.image}
                                        alt={item.name}
                                        style={{
                                            width: 40,
                                            height: 40,
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                        }}
                                    />
                                )}
                                <Typography variant="body2" fontWeight={600}>
                                    {item.name}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                );
            },
        },
        {
            field: "courseCount",
            headerName: "Courses",
            minWidth: 200,
            renderCell: ({ row, toggleExpand, isExpanded }) => {
                return (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            height: "100%",
                            gap: "12px",
                            cursor: "pointer",
                            position: "relative",
                        }}
                    >
                        <Chip
                            sx={{ background: "#DFEDFF", color: "#363853" }}
                            label={row.courseCount}
                        />

                        <Tooltip title="View Course List" arrow>
                            <Box
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                                onClick={() =>
                                    navigate("/university-listing-management/variant-course")
                                }
                            >
                                <EyeIcon sx={{ color: "#363853", fontSize: "20px" }} />
                            </Box>
                        </Tooltip>

                        <Tooltip title="View More Details" arrow>
                            <Box
                                className="clickmebtn"
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                                onClick={toggleExpand}
                            >
                                <ExpandCircleDownIcon
                                    sx={{
                                        color: isExpanded ? "#1976d2" : "#24ad24",
                                        transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                                        transition: "0.3s ease",
                                    }}
                                />
                            </Box>
                        </Tooltip>
                    </Box>
                );
            },
        },
        {
            field: 'specializationCount',
            headerName: 'Specializations',
            flex: 1,
            minWidth: 130,
            renderCell: (params) =>
                loading ? (
                    <Skeleton width={40} />
                ) : (
                    <Chip label={params.value} sx={{ background: '#DFEDFF', color: '#363853' }} />
                ),
        },
        {
            field: 'live',
            headerName: 'Go to Live',
            width: 100, // fixed because icon button
            renderCell: (params) =>
                loading ? (
                    <Skeleton variant="circular" width={24} height={24} />
                ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', height: '100%' }}>
                        <GoToLiveIcon />
                    </Box>
                ),
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            minWidth: 130,
            renderCell: (params) =>
                loading ? (
                    <Skeleton width={70} />
                ) : (
                    <Chip
                        label={params.value}
                        size="small"
                        icon={
                            <FiberManualRecordIcon
                                className={getStatusClass(params.value)}
                                sx={{
                                    fontSize: 10,
                                    color: getStatusColor(params.value),
                                }}
                            />
                        }
                        sx={{
                            bgcolor: getStatusBgColor(params.value),
                            color: getStatusTextColor(params.value),
                            fontWeight: 500,
                        }}
                    />
                ),
        },
        { field: "tag", headerName: "Tag" },
        { field: "enrollment", headerName: "Enrollment" },
        { field: "footer", headerName: "Footer" },
        { field: "homepage", headerName: "Homepage" },
        { field: "action", headerName: "Action" },
        { field: "createdDate", headerName: "Created Date" },
        { field: "lastUpdate", headerName: "Last Update" },
        { field: "email", headerName: "Email" },
        { field: "phone", headerName: "Phone" },
        { field: "studentHelp", headerName: "Student Helpline" },
    ];

    const [visibleColumns, setVisibleColumns] = useState(columns.map((c) => c.headerName));

    // filter the columns shown in the table
    const filteredColumns = columns.filter((col) =>
        visibleColumns.includes(col.headerName)
    );

    return (
        <>
            <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', }}>
                    <div className="row align-items-center">
                        <div className="col">
                            <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}><Link href="/" className='d-flex'><BackArrowIcon /></Link>University Listing Management </Typography>
                        </div>
                        <div className="col">  <Box display="flex" gap={2} sx={{ justifyContent: 'end', }}>

                            <Button onClick={() => navigate('/university-listing-management/university-details')} sx={{ background: '#0463EF', color: '#fff', minHeight: 'auto', padding: '4px 15px', fontSize: '14px', textTransform: 'capitalize', }}>
                                Add University
                            </Button>
                        </Box></div>
                    </div>
                    {/* End Col */}
                </div>
                <UniversitySummary type="university" isAdmin />
                <CommonFilterTab type="university" module={"admin"} detailType='University Details' searchPlaceholder='Search university...' fetchList={setSearchFilter} showCount={columns.length} isTag={true} isStatus={true} isEnrollment={true} searchFilter={searchFilter} />

                <Box sx={{ display: "flex", justifyContent: "end", padding: "10px 15px", gap: '10px' }}>
                    <ManageColumns
                        widgetOptions={columns.map((col) => col.headerName)}
                        defaultSelected={columns.map((col) => col.headerName)}
                        onChange={setVisibleColumns}
                    />
                    <Button variant="contained" onClick={() => setFiltersEnabled(!filtersEnabled)}>
                        <FilterListIcon /> Filter
                    </Button>
                </Box>
                <CommonDataTable columns={filteredColumns} rows={universityDataTable} idKey="id" loading={loading} filterEnabled={filtersEnabled} />
            </Box>
        </>
    );
};

export default UniversityManagement;
